import { vnTemplate } from "./vnTemplate";
import { infoButton_template } from "./infoButton_template";
export class filterSimple_template extends vnTemplate {
    constructor() {
        super(...arguments);
        this.delay = 400;
        this.lastRequestedValue = "";
    }
    getTemplateHtml() {
        return `
            <div class="w-search-feild icon" data-bind="css: iconClass">
            	<input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown', attr: { placeholder: placeholderText }" type="input" class="search-feild">
            	<input data-bind="value: filterKeywordLastKeyPress" type="hidden">
            	<input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
            	<button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="close-btn icon i-x-after" id="close-btn" type="button"></button>
                <div data-bind="visible: tooltipVisible" class="w-tooltips-adv auto-height">
                    ` + this.tooltip.getHtmlBuild() + `
                </div>
            </div>
            `;
    }
    getTemplateName() {
        return "filterSimple-template";
    }
    getMainElementClasses() {
        return ["filter-keyword-wrap"];
    }
    initPartial() {
        this.tooltip = new infoButton_template('toolTipSearch', this.getTemplateViewModel(), this.caller);
        this.tooltip.setTitle("Search Bar:");
    }
    buildViewModel() {
        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return { filterKeyword: ko.observable(""),
            filterKeywordLastKeyPress: ko.observable(""),
            filterKeywordRequestedKeyWord: ko.observable(""),
            filterInputClearButton: ko.observable(0),
            placeholderText: ko.observable(""),
            iconClass: ko.observable("i-search2"),
            onClearInput: function (data, event) { huit_neuf_this.onClearInput(event); },
            onKeyUpFilterAction: function (data, event) { huit_neuf_this.onKeyUpFilterAction(data, event); },
            tooltipVisible: ko.observable(false)
        };
    }
    /*
    *
    * Calls the caller definition of the "filterSimpleOnChange" function
    */
    onKeyUpFilterAction(data, event) {
        this.getTemplateViewModel().filterInputClearButton(1);
        clearTimeout(this.debounceTimerId);
        let _myThis = this;
        this.debounceTimerId = window.setTimeout(function () {
            _myThis.cancelFilter();
            _myThis.applyFilter();
        }, this.delay);
    }
    onClearInput(event) {
        this.getTemplateViewModel().filterInputClearButton(0);
        this.getTemplateViewModel().filterKeyword("");
        this.applyFilter();
    }
    clearInput() {
        this.getTemplateViewModel().filterInputClearButton(0);
        this.getTemplateViewModel().filterKeyword("");
    }
    applyFilter() {
        this.caller.filterSimpleOnChange(this.idElement);
    }
    cancelFilter() {
        this.caller.filterSimpleCancel();
    }
    setFilterKeyword(filterKeyword) {
        this.getTemplateViewModel().filterKeyword(filterKeyword);
        this.applyFilter();
    }
    setTooltipTitle(tooltipTitle) {
        this.tooltip.setTitle(tooltipTitle);
    }
    setTooltipContent(tooltipContent) {
        if (tooltipContent === '') {
            this.getTemplateViewModel().tooltipVisible(false);
        }
        else {
            this.getTemplateViewModel().tooltipVisible(true);
        }
        this.tooltip.setContent(tooltipContent);
    }
    setSearchableFields(searchableFields) {
        let mesg = "<p>This allows you to search partial matches, contained in the following fields:</p><ul><li>" + searchableFields.join(",</li><li>") + "</li></ul>";
        this.setTooltipContent(mesg);
    }
    // New configuration API
    setPlaceholder(placeholder) {
        this.getTemplateViewModel().placeholderText(placeholder || "");
    }
    setIconClass(iconCssClass) {
        // Keep default if falsy is provided
        this.getTemplateViewModel().iconClass(iconCssClass || "i-search2");
    }
}
